<ng-content select="elm-app-background"></ng-content>

<div fxLayout="column" class="elm-app-layout-container">
  <ng-content select="elm-app-header"></ng-content>

  <div fxFlex="auto" class="elm-app-content-container elm-app451-container-full">
    <ng-content select="elm-app-layout-content"></ng-content>
  </div>

  <ng-content select="elm-app-footer"></ng-content>
</div>
